import { Badge, Flex, Heading, Loader, Text, View } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { API, Auth } from "aws-amplify";
import { feeLabel, publicListingUrl } from "./listingModel";

// "Browse public collabs" (US-6). /public-listings is an open path: the Authorization header is sent
// only for consistency with the other gcAPI calls and is ignored server-side. The payload never
// carries uuid/SK by contract, so nothing here depends on them.
export function PublicListingsSection() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const request = { headers: { Authorization: `${user.signInUserSession.idToken.jwtToken}` } };
                const resp = await API.get("gcAPI", "/public-listings?limit=12", request);
                if (active) setItems(Array.isArray(resp) ? resp : []);
            } catch (error) {
                console.error("Error fetching public listings", error);
                if (active) setItems([]);
            }
            if (active) setLoading(false);
        })();
        return () => { active = false; };
    }, []);

    return (
        <View marginTop="30px">
            <Heading level={4} marginBottom="10px">Browse public collabs</Heading>
            <Flex direction="column" gap="15px">
                {loading ? <Loader variation="linear" /> : items.length === 0 ? (
                    <Text>No public collabs yet.</Text>
                ) : items.map((l) => (
                    <Flex key={l.slug} direction="row" alignItems="center" gap="15px" wrap="wrap"
                        padding="15px" border="1px solid #ccc" borderRadius="8px">
                        {l.imageUrl && <img src={l.imageUrl} alt="" style={{ maxHeight: 80, borderRadius: 4 }} />}
                        <View>
                            <Flex alignItems="center" gap="8px" wrap="wrap">
                                <Heading level={5}>
                                    <a href={publicListingUrl(l.slug)} target="_blank" rel="noreferrer">{l.title}</a>
                                </Heading>
                                <Badge variation="info">{l.listingType}</Badge>
                            </Flex>
                            <Text>{feeLabel(l)}</Text>
                            <Text variation="secondary">{Array.isArray(l.engagementTypes) ? l.engagementTypes.join(" · ") : ""}</Text>
                        </View>
                    </Flex>
                ))}
            </Flex>
        </View>
    );
}
